/* eslint eqeqeq: "off" */
import React, { useState } from "react";
import { Col, Row, Image, Divider } from "antd";
import {
  CommentOutlined,
  // LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import November from "../../assets/images/landing/places-visit-nov.jpg";
import December from "../../assets/images/landing/places-visit-dec.jpg";
import celebrations from "../../assets/images/landing/India-New-Year-Celebration.jpg";
import "./index.css";
import useMedia from "use-media-antd-query";

const ReadingCorners = () => {
  const media = useMedia();

  const [readMore, setReadMore] = useState(false);

  const slides = [
    {
      id: 1,
      content: (
        <Image
          preview={false}
          src={November}
          height={250}
          className="border border-solid"
          width={"100%"}
        />
      ),
      title: "Top 15 Places to Visit in India in November 2024",
    },
    {
      id: 2,
      content: (
        <Image
          preview={false}
          src={December}
          height={250}
          className="border border-solid"
          width={"100%"}
        />
      ),
      title: "11 Best Places to Visit in India in December 2024",
    },
    {
      id: 3,
      content: (
        <Image
          preview={false}
          src={celebrations}
          height={250}
          className="border border-solid"
          width={"100%"}
        />
      ),
      title: "New Year Celebrations in India: 10 Must-Visit Places",
    },
  ];

  return (
    <React.Fragment>
      <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
        <Row>
          <Col
            md={24}
            sm={24}
            lg={24}
            xl={24}
            xxl={24}
            className={
              media == "sm" || media == "xs"
                ? "pt-3 pb-3 pl-[40px] pr-[40px]"
                : "pt-3 pb-3 pl-[80px] pr-[80px]"
            }
            style={{
              fontFamily: "Poppins",
            }}
          >
            <div>
              <h1 className="text-[20px] font-semibold">Others Packages</h1>
            </div>
          </Col>
          <Col
            md={24}
            sm={24}
            lg={24}
            xl={24}
            xxl={24}
            className={
              media == "sm" || media == "xs"
                ? "pt-3 pb-3 pl-[40px] pr-[40px]"
                : "pt-3 pb-3 pl-[80px] pr-[80px]"
            }
          >
            <div
              className={
                media == "sm" || media == "xs"
                  ? "mt-[10px] mb-[25px] flex flex-col"
                  : "mt-[10px] mb-[25px] flex flex-row justify-between"
              }
            >
              {slides.map((slide, index) => (
                <div
                  key={slide.id}
                  className={
                    media == "sm" || media == "xs"
                      ? "h-[310px] pr-2 pl-2"
                      : "h-[250px] pr-2 pl-2"
                  }
                >
                  <h2 className="text-[black]">{slide.content}</h2>
                  <div className="h-[250px] w-[100%]">
                    <p
                      style={{
                        fontSize: "18px",
                        fontFamily: "Poppins",
                        fontWeight: 700,
                        marginBottom: "10px",
                        //   zIndex: 20,
                      }}
                    >
                      {slide.title}
                    </p>
                    <Divider
                      className={
                        media == "sm" || media == "xs"
                          ? "h-1 bg-[#eb3a3e]"
                          : index == 2
                          ? "h-1 bg-[#eb3a3e]"
                          : "h-1 bg-[#eb3a3e]"
                      }
                    />
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Col>
    </React.Fragment>
  );
};
export default ReadingCorners;
